import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

import { ItemService } from './item.service';

@Injectable()
export class DeviceService extends BaseService {

  constructor(
    private items: ItemService
  ) {
    super();
  }

  getDevice(id: number): Promise<any> {
    console.log('devices.getDevice()');

    return new Promise((resolve, reject) => {
      this.items.getItemById(id).then(
        (result) => {
          this.addDeviceDetail(result).then(
            (result) => {
              resolve(result);
            },
            (err) => {
              console.error('error adding device detail', err);
              reject(err);
            });
        },
        (err) => {
          console.error('error getting device', err);
          reject(err);
        });
    });
  }

  private addDeviceDetail(item: any): Promise<any> {
    console.log('devices.addDeviceDetail()');

    return new Promise((resolve, reject) => {
      if (item.type === 6) { // protocol
        this.items.getChildren(item.id, { typeName: 'device' }).then(
          (result) => {
            item.proxiesByName = new Map<string, any>();
            item.proxiesById = new Map<number, any>();
            result.forEach((proxy) => {
              item.proxiesByName.set(proxy.proxy, proxy);
              item.proxiesById.set(proxy.id, proxy);
            });
            item.defaultProxy = item.proxiesByName.get(item.proxy);

            resolve(item);
          },
          (err) => {
            console.log('error getting children', err);
            reject(err);

          });
      } else if (item.type === 7) { // proxy
        console.log('TODO: get parent protocol for proxy');
        resolve(item);
      } else {
        resolve(item);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/device.service.ts